import React, { useEffect, useState } from "react";
import girlimg from "../../assets/images/png/girlProfilepic.png";
import reviewedStart from "../../assets/images/png/reviewedStars.png";
import deepakMehta from "../../assets/images/png/deepakMehta.png";
import greyStar from "../../assets/images/png/greyStar.png";
import yellowStar from "../../assets/images/png/yellowStar.png";
import { getReview, postReview } from "../../services/ReviewServices";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const ProductsReview = ({ paddingTop }) => {
  const [liked, setLiked] = useState(0);
  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [quote, setQuote] = useState("");
  const [describe, setDescribe] = useState("");
  const [reviews, setReviews] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const [nameError, setNameError] = useState(false);
  const [mailError, setMailError] = useState(false);
  // const [quoteError, setQuoteError] = useState(false);
  const [describeError, setDescribeError] = useState(false);
  const [reviewStarError, setReviewStarError] = useState(false);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const review = async () => {
    const tokenItem = localStorage.getItem("token");
    const reviewData = {
      rating: liked,
      description: describe,
      productId: id,
      name: name,
      email: mail,
    };
    if (tokenItem) {
      if (!name.trim()) {
        setNameError(true);
        return toast.error("Please fill are required fields");
      }
      if (!validateEmail(mail.trim())) {
        setMailError(true);
        return toast.error("Please enter valid email address");
      }
      // if (!quote.trim()) {
      //   setQuoteError(true);
      //   return;
      // }
      if (!describe.trim()) {
        setDescribeError(true);
        return toast.error("Please fill are required fields");
      }
      if (liked === 0) {
        setReviewStarError(true);
        return toast.error("Please fill are required fields");
      }
      const res = await postReview(reviewData, tokenItem);
      if (res.status === "success") {
        setLiked(0);
        setName("");
        setMail("");
        setQuote("");
        setDescribe("");
        getreviews();
      }
    } else {
      localStorage.setItem("path", `/product-details/${id}`);
      navigate("/signin");
    }
  };

  const getreviews = async () => {
    const tokenItem = localStorage.getItem("token");
    const res = await getReview(id, tokenItem);
    setReviews(res.data);
  };

  useEffect(() => {
    getreviews();
  }, []);

  const convertDate = (x) => {
    const d = new Date(x);
    const options = { month: "long", day: "numeric", year: "numeric" };
    return d.toLocaleDateString("en-US", options);
  };

  const handleStarClick = (index) => {
    setLiked((prevLiked) => (prevLiked === index ? 0 : index));
    setReviewStarError(false);
  };

  return (
    <div className={`${paddingTop} pt-4`}>
      <ToastContainer />
      <div className="">
        <div className="bg-white p-4 rounded-2">
          <h4 className="text-uppercase ff_heebo clr_dark_blue fs_md lh-26 fw-bold">
            reviews ({reviews && reviews.length})
          </h4>
          <div className="light-grey-hr-line w-100 position-relative">
            <div className="green-hr-line green-hr-line-width"></div>
          </div>
          <div
            className={
              reviews && reviews.length >= 1
                ? "review-box px-md-5 py-md-4 py-2 px-3 mt-3 d-block"
                : "d-none"
            }
          >
            {reviews &&
              reviews.map((items, index) => {
                const name = items?.name;
                let initials = "";

                if (name) {
                  const words = name.split(" ");
                  initials = words.reduce((acc, curr) => acc + curr[0], "");
                }
                return (
                  <div className="mt-4" key={index}>
                    <div className="d-flex align-items-center gap-3">
                      <div className="img-border d-flex align-items-center">
                        <div className="initial-letters-bg d-flex align-items-center justify-content-center">
                          <p className="fs_2xl ff_inter text-white mb-0 text-uppercase">
                            {initials}
                          </p>
                        </div>
                      </div>
                      <div>
                        <p className="mb-0 ff_heebo clr_dark_blue fw-medium fs_xsm">
                          {items?.name} -{" "}
                          <span className="fw-normal clr_dark_grey_2">
                            {convertDate(items?.createdAt)}
                          </span>
                        </p>
                        <div>
                          <div className="d-flex align-items-center mt-1">
                            {Array.from({ length: 5 }, (_, index) => (
                              <img
                                key={index}
                                style={{ width: "16px", height: "14px" }}
                                src={
                                  index < items?.rating ? yellowStar : greyStar
                                }
                                alt="review"
                              />
                            ))}
                            {/* <p className="mb-0 ff_heebo clr_dark_blue fw-medium fs_xsm ps-1">
                            - For Product Quality
                          </p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <p className="clr_dark_grey_2 ff_heebo fs_xsm lh-26 mt-3 description-m-width">
                      {items?.description}
                    </p>
                    <div className="review-box-hr-line mt-4"></div>
                  </div>
                );
              })}
          </div>
          <div className="text-center">
            <div className="d-flex align-items-center justify-content-center mt-5">
              {[1, 2, 3, 4, 5].map((index) => (
                <div key={index} onClick={() => handleStarClick(index)}>
                  {liked >= index ? (
                    <img
                      width={40}
                      height={36.35}
                      src={yellowStar}
                      alt="star"
                    />
                  ) : (
                    <img width={40} src={greyStar} alt="star" />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between gap-lg-5 gap-4 mt-4 flex-column flex-lg-row">
            <div className="w-100">
              <input
                className={`input-boxes px-3 clr_dark_grey_4 w-100 ${
                  nameError ? "error" : ""
                }`}
                placeholder="Name"
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setNameError(false);
                }}
              />
            </div>
            <div className="w-100">
              <input
                className={`input-boxes px-3 clr_dark_grey_4 w-100 ${
                  mailError ? "error" : ""
                }`}
                placeholder="Email"
                type="mail"
                value={mail}
                onChange={(e) => {
                  setMail(e.target.value);
                  setMailError(false);
                }}
              />
            </div>
            <div className="w-100">
              <input
                className="input-boxes px-3 clr_dark_grey_4 w-100"
                placeholder="Quote"
                type="text"
                value={quote}
                onChange={(e) => {
                  setQuote(e.target.value);
                }}
              />
              {/* {quoteError && (
                <span className="error-text">Quote is required</span>
              )} */}
            </div>
          </div>
          <div className="w-100 mt-4">
            <textarea
              rows={4}
              className={`input-text-area px-3  pt-3 clr_dark_grey_4 w-100 ${
                describeError ? "error" : ""
              }`}
              placeholder="Describe"
              value={describe}
              onChange={(e) => {
                setDescribe(e.target.value);
                setDescribeError(false);
              }}
            />
          </div>

          <div className="text-end">
            <button
              onClick={review}
              style={{ height: "40px" }}
              className="common-darkgreen-button mt-4 text-uppercase px-4 ff_heebo fw-medium text-white text-uppercase rounded-3 fs_xxsm"
            >
              drop your review
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsReview;
